import { Button, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import axios from "axios";
import React, { useState, useEffect } from "react";
import baseURL from "../../../../../configs/api";
import axois from "../../../../../configs/axois";
import { validateMin } from "../../../../../utils/validateMin";
import { useTheme } from "../../../../../components/hooks/useTheme";
import { useLocation, useNavigate } from "react-router-dom";
import PleaseWaitPopup from "../../../../PleaseWaitPopup";
import useDelete from "../../../../../components/hooks/useDelete";
import colorConfigs from "../../../../../configs/colorConfigs";
import useAuth from "../../../../../components/hooks/useAuth";
import Cookies from "js-cookie";
import useTenant from "../../../../../components/hooks/useTenant";

export const EditMaintenanceTypes = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const idNumber = useLocation();
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const { setDeletePopup, setData: setDeleteData }: any = useDelete();
  const [isGeneralSettings, setIsGeneralSetttings] = useState<boolean>(true);
  const [isDefaultSettings, setIsDefaultSettings] = useState<boolean>(true);
  const [maintenanceName, setMaintenanceName] = useState<string>("");
  const [isActive, setIsActive] = useState<string>("No");
  const [isRecurring, setIsRecurring] = useState<string>("No");
  const [defaultTotalInParts, setDefaultTotalInParts] = useState<string>("");
  const [defaultTotalInLabor, setDefaultTotalInLabor] = useState<string>("");
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(true);

  useEffect(() => {
    axois
      .get(`${baseURL}maintenanceType/${idNumber?.state}`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setMaintenanceName(response?.data?.maintenanceName);
        setIsActive(response?.data?.isActive ? "Yes" : "No");
        setIsRecurring(response?.data?.isRecurring ? "Yes" : "No");
        setDefaultTotalInParts(response?.data?.defaultTotalInParts);
        setDefaultTotalInLabor(response?.data?.defaultTotalInLabor);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idNumber]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!pleaseWaitPopup) {
      setPleaseWaitPopup(true);

      axios
        .put(
          `${baseURL}maintenanceType?userId=${auth?.id}`,
          JSON.stringify({
            id: idNumber?.state,
            maintenanceName,
            isActive: isActive === "Yes",
            isRecurring: isRecurring === "Yes",
            defaultTotalInParts,
            defaultTotalInLabor,
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then(() => {
          setPleaseWaitPopup(false);
          navigate(-1);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    }
  };

  const deleteMaintenanceType = () => {
    setDeleteData({
      id: idNumber,
      tilte: `Delete`,
      summary: `Are you sure you want to delete this Maintenance Type?`,
      isDelete: (callback: any) => {
        setPleaseWaitPopup(true);

        fetch(`${baseURL}maintenanceType?id=${idNumber?.state}&userId=${auth?.id}`, {
          method: 'DELETE',
          headers: {
            'X-Tenant-ID': tenantId,
          }
        })
          .then(() => {
            setPleaseWaitPopup(false);
            navigate(-1);
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });

        callback();
      }
    });

    setDeletePopup(true);
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>
              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Maintenance Type</h2>
                </div>

                {
                  disabled && (
                    <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                      onClick={() => setDisabled(false)}
                    >
                      <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                        edit
                      </span>
                      <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                    </button>
                  )
                }
              </div>

              <div className="mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <h5
                    className="mb-0 flex items-center cursor-pointer select-none"
                    onClick={() => setIsGeneralSetttings(!isGeneralSettings)}
                  >
                    {isGeneralSettings ? (
                      <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    ) : (
                      <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    )}
                    <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                      General Settings
                    </div>
                  </h5>
                  <hr />

                  <div className="w-full px-2">
                    {isGeneralSettings &&
                      <div className="grid grid-cols-3 gap-6">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Label</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={maintenanceName}
                              disabled={disabled}
                              onChange={(e) => setMaintenanceName(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                            <RadioGroup
                              row
                              value={isActive}
                              onChange={(e) => setIsActive(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Is Recurring?</label>
                            <RadioGroup
                              row
                              value={isRecurring}
                              onChange={(e) => setIsRecurring(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>
                      </div>
                    }
                    <h5
                      className="mb-0 mt-4 flex items-center cursor-pointer select-none"
                      onClick={() => setIsDefaultSettings(!isDefaultSettings)}
                    >
                      {isDefaultSettings ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Default Settings
                      </div>
                    </h5>
                    <hr />
                    {isDefaultSettings &&
                      <div className="grid grid-cols-3 gap-6 mt-2">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Default Total in Parts</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={defaultTotalInParts}
                              disabled={disabled}
                              onChange={(e) => setDefaultTotalInParts(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Default Total in Labor</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[6px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={defaultTotalInLabor}
                              disabled={disabled}
                              onChange={(e) => setDefaultTotalInLabor(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>
                        </div>
                      </div>
                    }

                    <div className="flex gap-4 mt-6">
                      {
                        !disabled && (
                          <Button variant="contained"
                            sx={{
                              backgroundColor: colorConfigs.btn.main.bg
                            }}
                            type="submit"
                          >
                            Save
                          </Button>
                        )
                      }

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.delete.bg,
                        }}
                        onClick={deleteMaintenanceType}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}
